<template>
  <a-modal v-model="modal" title="新建" width="500px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="材料编码(主)"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="primaryItemCode"
          :rules="rules.primaryItemCode"
        >
          <global-select
            ref="materils1"
            v-model="formData.primaryItemCode"
            selectType="selectSearch"
            :focusGet="true"
            :dropdown-match-select-width="false"
            requestApi="/scp/scpMrpSystemItems/planItemsBox"
            :selectItem="{ value: 'selectedValue', label: 'label' }"
            :setParams="{ organizationCode: 'A001' }"
            searchParam="label"
            sourseField="res"
            :totalNum="9999999999"
          />
        </a-form-model-item>
        <a-form-model-item
          label="材料编码(辅)"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="secondaryItemCode"
          :rules="rules.secondaryItemCode"
        >
          <global-select
            ref="materils2"
            v-model="formData.secondaryItemCode"
            selectType="selectSearch"
            :focusGet="true"
            :dropdown-match-select-width="false"
            requestApi="/scp/scpMrpSystemItems/planItemsBox"
            :selectItem="{ value: 'selectedValue', label: 'label' }"
            :setParams="{ organizationCode: 'A001' }"
            searchParam="label"
            sourseField="res"
            :totalNum="9999999999"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiMaterialMatchColorConfigAdd } from '@/api/color-management/color-relation/colorRelationApi'

export default {
  name: 'CreateMaterialModal',
  data() {
    return {
      modal: false,
      formData: {
        primaryItemCode: "", // 材料编码(主)
        secondaryItemCode: '' // 材料编码(辅)
      },
      loading: false,
      rules: {
        primaryItemCode: [{ required: true, message: ' ', trigger: 'change' }],
        secondaryItemCode: [{ required: true, message: ' ', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 初始化
    show () {
      this.$set(this.formData, 'primaryItemCode', '')
      this.$set(this.formData, 'secondaryItemCode', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          if(this.formData.primaryItemCode === this.formData.secondaryItemCode) {
            this.$message.warning('主辅材料不能相同')
            return
          }
          this.loading = true;
          apiMaterialMatchColorConfigAdd(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
